import { FC } from 'react'
import {
  AlertTriangle, AlertCircle, ClipboardCheck, SearchCheck, ShieldAlert,
  FileSignature, FileSpreadsheet, Siren, Users, FolderOpen, Award,
} from 'lucide-react'

interface QuickAction {
  label: string
  sub: string
  route: string
  icon: FC<{ className?: string }>
}

const actions: QuickAction[] = [
  { label: 'Report Defect', sub: 'Log a new defect', route: '/qhse/defects-list', icon: AlertTriangle },
  { label: 'Submit Near Miss', sub: 'Report near miss', route: '/qhse/accident-near-miss-reports', icon: AlertCircle },
  { label: 'New Audit', sub: 'Schedule audit', route: '/qhse/audit-index', icon: ClipboardCheck },
  { label: 'Inspection', sub: 'Plan inspection', route: '/qhse/inspindex', icon: SearchCheck },
  { label: 'Risk Assessment', sub: 'Create assessment', route: '/qhse/risk-assessment', icon: ShieldAlert },
  { label: 'Work Permit', sub: 'Issue permit', route: '/qhse/work-permits-and-checklists', icon: FileSignature },
  { label: 'Month-End Report', sub: 'Submit report', route: '/qhse/month-end-reports', icon: FileSpreadsheet },
  { label: 'Record Drill', sub: 'Log emergency drill', route: '/qhse/emergency-drills/report', icon: Siren },
  { label: 'Safety Meeting', sub: 'Committee minutes', route: '/qhse/safety-committee-meeting', icon: Users },
  { label: 'Forms Library', sub: 'View checklists', route: '/qhse/forms-checklists/library', icon: FolderOpen },
  { label: 'Certificates', sub: 'Upload certificate', route: '/qhse/vessel-certificates', icon: Award },
]

const actionRoutes: Record<string, string> = {}
actions.forEach((a) => { actionRoutes[a.label] = a.route })


interface Props {
  onAction: (label: string) => void
}

const QuickActions: FC<Props> = ({ onAction }) => (
  <div>
    <div className='flex items-center gap-2 mb-3'>
      <h4 className='text-xs font-semibold text-slate-500 uppercase tracking-wider'>Quick Actions</h4>
    </div>
    <div className='grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-3'>
      {actions.map((action, i) => {
        const Icon = action.icon
        return (
          <button key={i}
            onClick={() => onAction(action.label)}
            className='flex flex-col items-center gap-1.5 p-3 bg-white rounded-xl border border-slate-200 shadow-sm hover:border-blue-300 hover:shadow-md transition-all text-center'
          >
            <div className='w-8 h-8 rounded-lg bg-rose-50 flex items-center justify-center'>
              <Icon className='w-4 h-4 text-rose-600' />
            </div>
            <div className='text-[11px] font-semibold text-slate-800 leading-tight'>{action.label}</div>
            <div className='text-[9px] text-slate-400 leading-tight'>{action.sub}</div>
          </button>
        )
      })}
    </div>
  </div>
)

export { actionRoutes }
export default QuickActions
